import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from "@components";
import { ActionResultList, CompetitorResults, EventItem, EventItemType, Lookups, Message, Race, UserDetail } from "@model";
import { PublicEventsService } from '@services';
import { EVENT_DETAILS } from 'src/app/app-routing.module';

@Component({
  selector: 'app-user-profile-dashboard-tab',
  templateUrl: './user-profile-dashboard-tab.component.html',
  styleUrls: ['./user-profile-dashboard-tab.component.scss']
})
export class UserProfileDashboardTabComponent extends AbstractComponent implements OnInit {
  @Input() countries: Lookups[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() races: Race[] = [];
  @Input() raceUpcomingEvents: Race[] = [];
  @Input({ required: true }) page = 1;
  @Input({ required: true }) pageSize = 10;
  @Input() isAdmin = false;
  @Input() favoriteItems: EventItem[] = [];
  @Input() raceResultsMap = new Map<Race, CompetitorResults[]>();
  @Input() currentUserDetails?: UserDetail;
  @Input() unreadMessages?: Message[];
  @Input() users: UserDetail[] = [];
  protected readonly EventItemType = EventItemType;

  constructor(
    private publicEventService: PublicEventsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToFavoritesChange();
  }

  subscribeToFavoritesChange(): void {
    this.subscriptions.push(
      this.publicEventService.favoriteEvents.subscribe((value: ActionResultList<EventItem[], number> | null) => {
        this.favoriteItems = value?.result ?? [];
      })
    );
  }

  goToEventDetailsPage(item: EventItem): void {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: { eventId: item.id }
    });
  }

  onScroll(event: any): void {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.page++;
    }
  }
}
